export default {
    inviteToScrolls: 'Add to the list',
    inviteToBoards: 'Invite to the platform'
};
